
import React from "react";

const Mark = () => {
  return (
    <div style={styles.container}>
      <iframe
        src="https://script.google.com/macros/s/AKfycbx7fjSXPy1b6YI-97fgExJjzZkE4gLdcZ2Knqt53DTniu7xe_X-zRAEZTXJiYkQPbUM/exec


"
        title="Attendance 5"
        style={styles.iframe}
      />
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100vh",
    overflow: "hidden", // 🚀 prevents double scroll
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
  },
};

export default Mark;